<template>
  <div
    class="flex justify-between pl-3 pr-2 pt-2 pb-0 items-center whitespace-nowrap text-sm text-bc-blue"
  >
    <div>
      <span class="font-semibold">{{ monthHuman(month) }}</span>
      <span class="ml-1 font-semibold">{{ year }}</span>
    </div>
    <div>
      <button
        type="button"
        class="inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:outline-none"
        @click="prevMonth()"
      >
        <svg
          class="h-5 w-5 text-bc-blue inline-flex"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
      <button
        type="button"
        class="inline-flex cursor-pointer hover:bg-gray-200 p-1 rounded-full focus:outline-none"
        @click="nextMonth()"
      >
        <svg
          class="h-5 w-5 text-bc-blue inline-flex"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>

  <div class="flex flex-wrap text-sm  py-1.5 whitespace-nowrap">
    <div
      style="width: 14.28%"
      class=""
      v-for="(day, index) in daysOfWeek"
      :key="index"
    >
      <div class="text-center">{{ day }}</div>
    </div>
  </div>

  <div class="Calendar__Days text-sm whitespace-nowrap pb-2">
    <div
      class="text-center border border-transparent text-sm"
      v-for="blankday in blankDays"
      :key="blankday"
    ></div>
    <div
      class="flex items-center justify-center"
      v-for="(date, dateIndex) in days"
      :key="dateIndex"
    >
      <div
        @click="selectDay(date)"
        class="cursor-pointer text-center text-sm leading-none w-7 rounded-full leading-loose"
        :class="{
          'bg-gray-200': isToday(date) === true,
          'hover:bg-gray-200': isToday(date) === false,
          '!bg-bc-blue !text-white': isSelected(date)
        }"
      >
        {{ date }}
      </div>
    </div>
  </div>
</template>
<script>
// import formatDate from 'nette-base-module/js/utils/formatDate'

const WEEKDAYS2DAYS = [6, 0, 1, 2, 3, 4, 5]

export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      required: false,
      type: Date,
      default: new Date()
    }
  },
  data() {
    const modelValue =
      this.$props.modelValue && this.$props.modelValue.getTime() > 0
        ? this.$props.modelValue
        : new Date();
    return {
      month: modelValue.getMonth(),
      year: modelValue.getFullYear(),
      monthNames: [
        this.$t("January"),
        this.$t("February"),
        this.$t("March"),
        this.$t("April"),
        this.$t("May"),
        this.$t("June"),
        this.$t("July"),
        this.$t("August"),
        this.$t("September"),
        this.$t("October"),
        this.$t("November"),
        this.$t("December")
      ],
      daysOfWeek: [
        this.$t("Mo"), 
        this.$t("Tu"), 
        this.$t("We"), 
        this.$t("Th"), 
        this.$t("Fr"), 
        this.$t("Sa"), 
        this.$t("Su")
      ]
    };
  },
  computed: {
    blankDays() {
      let dayOfWeek = WEEKDAYS2DAYS[new Date(this.year, this.month).getDay()];
      const ret = [];
      for (var i = 1; i <= dayOfWeek; i++) {
        ret.push(i);
      }

      return ret;
    },
    days() {
      let daysInMonth = new Date(this.year, this.month + 1, 0).getDate();
      const ret = [];
      for (var i = 1; i <= daysInMonth; i++) {
        ret.push(i);
      }

      return ret;
    }
  },
  watch: {
    modelValue(val) {
      if (!val || val.getTime() === 0) val = new Date();
      this.month = val.getMonth();
      this.year = val.getFullYear();
    }
  },
  methods: {
    monthHuman(month) {
      return this.monthNames[month];
    },
    isToday(day) {
      const today = new Date();
      const d = new Date(this.year, this.month, day);
      return today.toDateString() === d.toDateString() ? true : false;
    },
    isSelected(day) {
      const d = new Date(this.year, this.month, day);
      return this.$props.modelValue.toDateString() === d.toDateString()
        ? true
        : false;
    },
    prevMonth() {
      if (this.month === 0) {
        this.year--;
        this.month = 11;
      } else {
        this.month--;
      }
    },
    nextMonth() {
      if (this.month === 11) {
        this.year++;
        this.month = 0;
      } else {
        this.month++;
      }
    },
    selectDay(day) {
      const selectedDate = new Date(this.year, this.month, day);
      this.$emit("update:modelValue", selectedDate);
    }
  }
};
</script>

<style lang="scss" scoped>
.Calendar__Days {
  @apply grid;
  gap: 2px;
  grid-template-columns: repeat(7, 1fr);
  // grid-auto-rows: 42px;
}
</style>
